import { render, staticRenderFns } from "./AttendanceTeacherDetail.vue?vue&type=template&id=09c37f5a"
import script from "../../controllers/attendance_teacher/attendance-teacher-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/attendance_teacher/attendance-teacher-detail.js?vue&type=script&lang=js&external"
import style0 from "./AttendanceTeacherDetail.vue?vue&type=style&index=0&id=09c37f5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports